import React, { useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import LoadingOverlay from '../../components/LoadingOverlay';
import Button from '../../components/Button';
import ContainerPage from '../../components/ContainerPage';
import HeadTitle from '../../components/HeadTitle';
import DateSlots from './components/DateSlots';

import { ScheduleContext } from '../../contexts/ScheduleContext';
import { RouterContext } from '../../contexts/RouterContext';

import { PAGES } from '../../Router/pages';

import * as S from './styles';
import { gtmEvent } from '../../utils/gtm';
import { format } from 'date-fns';
import { ModuleContext } from '../../contexts/ModuleContext';
import { SlotHour } from '../../modules/slots';
import { useSchedulingMount } from '../../hooks/useSchedulingMount';

export type DisplayTimes = {
  id: string;
  time: Date;
  slots: SlotHour[];
};

type AvailableTimeSchedule = { [x: string]: SlotHour[] };

type AvailableSchedule = {
  [x: string]: AvailableTimeSchedule;
};

export type UnitTimesProps = {
  address: string;
  availableTimes: AvailableSchedule;
  closestDate: string;
  unit: string;
  unitId: string;
};

const DateTime: React.FC = () => {
  const {
    selectedItem,
    setSelectedItem,
    changeSchedule,
    scheduleItems,
    scheduleSpecialistSelected,
    changeScheduleSpecialist
  } = useContextSelector(ScheduleContext, state => state);

  const { selectedItemToSchedule: itemToSchedule } = useContextSelector(ModuleContext, state => state);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [specialistInterval, setSpecialistInterval] = useState(0);
  const [selectedTime, setSelectedTime] = useState<DisplayTimes | undefined>();
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [hasScheduleSameDateTime, setHasScheduleSameDateTime] = useState(false);

  const useScheduling = useSchedulingMount({ selectedSchedule: selectedItem, changeSchedule });

  const { goTo, goBack } = useContextSelector(RouterContext, state => state);

  const handleGoBack = () => {
    if (selectedItem?.channel === 'TELEORIENTATION') goTo(PAGES.SERVICE_LIST.id);
    else goBack();
  };

  function handleContinue() {
    if (itemToSchedule === 'SPECIALIST' && selectedDate && selectedTime) {
      changeScheduleSpecialist({
        ...scheduleSpecialistSelected,
        date: format(selectedDate, 'yyyy-MM-dd'),
        hour: format(selectedTime.time, 'HH:mm'),
        interval: specialistInterval
      });
      goTo(PAGES.APPOINTMENT_CONFIRMATION.id);
    }
    if (itemToSchedule === 'PRODUCT' || itemToSchedule === 'PRODUCT_ENV' || itemToSchedule === 'SERVICE_ENV')
      if (selectedItem && selectedTime && selectedDate) {
        useScheduling.addSlotsOptions(selectedTime.slots);
        useScheduling.addTime(selectedTime);
        useScheduling.updateSchedule();
        gtmEvent({
          event: 'agendamento-einstein',
          categoria: selectedItem.productName?.includes('gripe') ? 'Agendar-Vacina' : 'Agendar',
          acao: 'step-5',
          rotulo: 'data-e-horario'
        });
        goTo(PAGES.APPOINTMENT_CONFIRMATION.id);
      }
  }

  return (
    <ContainerPage
      childrenFooter={
        <Button
          title="Continuar"
          disabled={!selectedDate || !selectedTime || hasScheduleSameDateTime}
          onClick={handleContinue}
        />
      }
    >
      <HeadTitle title="Data e horário" goBack={handleGoBack} />
      <DateSlots
        schedules={scheduleItems}
        schedule={selectedItem}
        setSelectedSchedule={setSelectedItem}
        setHasScheduleSameDateTime={setHasScheduleSameDateTime}
        setLoadingSlots={setLoadingSlots}
        setSelectedDate={setSelectedDate}
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        setSelectedTime={setSelectedTime}
        selectedItemToSchedule={itemToSchedule}
        scheduleSpecialist={scheduleSpecialistSelected}
        handleGoBack={handleGoBack}
        setSpecialistInterval={setSpecialistInterval}
      />
      <LoadingOverlay loading={loadingSlots} />
    </ContainerPage>
  );
};

export default DateTime;
